<template>
  <div class="form-log-content">
    <div class="log" v-for="log in logs" :key="log.id">
      <div class="log-content">
        <div class="creator" :title="log.creator">{{log.creator}}</div>
        <div class="content">{{log.content}}</div>
      </div>
      <div class="log-time">{{log.createdDate}}</div>
    </div>
    <div class="logs-empty" v-if="logs.length === 0">
      <img src="../assets/discuss-log-empty.png">
      <span>暂无日志</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'log-component',
  props: {
    dataId: {
      type: String,
      required: true
    },
    dataState: String
  },
  data () {
    return {
      logs: []
    }
  },
  created () {
    // 日志只在初始化时加载一次, 新建的时候不请求
    if (this.dataState !== 'create') {
      this.getFormLog()
    }
  },
  methods: {
    getFormLog () {
      this.$axios.get(`/form-api/discuss/log/${this.dataId}`, {params: {
        size: -1,
        filters: {
          start: 0
        }
      }}).then(res => {
        if (res.data.items) {
          this.logs = res.data.items.map(log => {
            return {
              creator: log.creator,
              content: log.content,
              dataId: log.dataId,
              formId: log.formId,
              createdDate: log.createdDate ? moment(log.createdDate).format('YYYY年MM月DD日 HH:mm:ss') : '',
              id: log.id
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .form-log-content{
    height: 100%;
    overflow-y: scroll;
    .log{
      margin-bottom: 30px;
      .log-content{
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        .creator{
          width: 60px;
          flex-shrink: 0;
          flex-grow: 0;
          font-size: 12px;
          color: var(--primary, #55ACF1);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          line-height: 20px;
        }
        .content{
          width: calc(100% - 60px);
          color: #2C2C2C;
          line-height: 20px;
        }
      }
      .log-time{
        color: #767D80;
        font-size: 12px;
      }
    }
    .logs-empty{
      display: flex;
      flex-direction: column;
      margin-top: 80px;
      align-items: center;
      img{
        margin-bottom: 15px;
      }
      span{
        color: #767D80;
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/discussLogComponents/log-component.vue